(function ($) {
    $.fn.funderCarousel = function () {
        return this.each(() => {
            let slider;
            const $self = $(this);
            const $slider = $self.find('.container .splide');
            let slideCount = $self.find('.splide .splide__slide').length;



            slider = new window.Splide($slider[0], {
                type: 'loop',
                perPage: (slideCount < 7 ? slideCount : 7),
                autoplay: true,
                interval: 0,
                speed: 1000,
                easing: 'linear',
                pauseOnHover: true,
                perMove: 1,
                arrows: false,
                pagination: false,
                breakpoints: {
                    990: {
                        perPage: (slideCount < 6 ? slideCount : 6), // or 'completely'
                    },
                    640: {
                        perPage: (slideCount < 3 ? slideCount : 3),
                    },
                },
            });


            // On slider mounted
            slider.on('mounted', function () {
                // If slide count is less than 10 calculate width 
                if (slideCount < 10) {
                    $slider.css('max-width', (slideCount * 160) + 'px');
                }
            });

            slider.mount();
        });
    }

    $(() => {
        $('.funder_logo_carousel').funderCarousel();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/modules/blocks/funder-carousel.js